module.exports = __webpack_public_path__ + "static/media/thank2.4026e6dc.png";